{
  "dss": {
    "footer": {
      "legalEntity": "STIHL LIMITED"
    },
    "link": {
      "contact": "https://support.stihl.com/en-nz/websso-ext-contact/",
      "faq": "https://support.stihl.com/en-nz/externalkbsearchwebsso/"
    }
  }
}
